import { useState } from "react";
import { StoreProductCardtype } from "../type";
import { Modal } from "antd";
import BuyProductPopUp from "./buyProductPopUp";

interface StoreProductCardProps extends StoreProductCardtype {
    key?: number;
}

const StoreProductCard: React.FC<StoreProductCardProps> = (props) => {
    const [isBuyOpen, setIsBuyOpen] = useState(false);
    return (
        <div className="bg-white rounded-[3px] !shadow-md hover:!shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="relative h-1/3">
                <img
                    src={props.image}
                    alt={props.name}
                    className="w-full h-48 object-cover"
                />
                {props.indicator && (
                    <div className="absolute top-4 left-4 bg-orange-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                        {props.indicator}
                    </div>
                )}
                <div className="absolute top-4 right-4 bg-purple-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                    🚀 {props.platform}
                </div>
            </div>
            <div className="p-6 flex flex-col justify-between h-2/3">
                <div>
                    <div className="flex items-start justify-between mb-2">
                        <h3 className="!text-2xl font-bold text-gray-900">{props.name}</h3>
                        <div className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star h-4 w-4 text-yellow-400 fill-current"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                            <span className="!text-sm font-medium">{props.star}</span>
                            <span className="!text-xs text-gray-500">({props.review})</span>
                        </div>
                    </div>
                    <p className="text-gray-600 !text-sm mb-4 line-clamp-2">{props.description}</p>
                </div>
                <div className="flex flex-col">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                            <span className="text-2xl font-bold text-gray-900">{props.finalPrice}</span>
                            {props.discount && (
                                <span className="text-sm text-gray-500 line-through">{props.price}</span>
                            )}
                        </div>
                    </div>
                    <div className="flex flex-row gap-2">
                        <button
                            className="flex-1 flex items-center justify-center gap-2 bg-gray-100 !text-gray-700 px-2 py-2 !rounded-[3px] hover:bg-gray-200 transition duration-300">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-4 w-4"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            Detail
                        </button>
                        <button
                            onClick={() => setIsBuyOpen(true)}
                            className="flex-1 flex items-center justify-center gap-2 bg-blue-600 !text-white px-2 py-2 !rounded-[3px] hover:bg-blue-700 transition duration-300">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart h-4 w-4"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
                            Buy Now
                        </button>
                        <Modal
                            title={
                                <div className="flex flex-col px-6 pt-4 rounded items-start bg-gradient-to-r from-blue-50 to-indigo-50">
                                    <h2 className="!text-2xl font-bold text-gray-900 !mb-0">Checkout</h2>
                                    <p className="text-gray-600">Secure payment via PayPal</p>
                                </div>
                            }
                            styles={{
                                header: {
                                    padding: 0,
                                },
                                content: {
                                    padding: 0,
                                },
                                body: {
                                    padding: 8,
                                }
                            }}
                            style={{
                                top: 20,
                            }}
                            open={isBuyOpen}
                            onCancel={() => setIsBuyOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <BuyProductPopUp
                                id={props.id}
                                name={props.name}
                                finalPrice={props.finalPrice}
                                price={props.price}
                                image={props.image}
                                description={props.description}
                                indicator={props.indicator}
                                platform={props.platform}
                                star={props.star}
                                review={props.review}
                            />
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StoreProductCard;